// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Textarea_wrapper__1Ar95","title":"Textarea_title__2B1Ci","textarea":"Textarea_textarea__3SOgQ","textareaWithBorder":"Textarea_textareaWithBorder__1qWOZ"};